module.exports = __webpack_public_path__ + "static/downloable/solicitud_de_anulación_de_poliza.56e85d6.docx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloable/solicitud_de_anulación_de_poliza.docx
// module id = xuBo
// module chunks = 1